import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import lazySizes from 'lazysizes';
import CookiePopup from './components/cookie'
import NCookiePopup from './components/ncookie'
import Slider from "./components/hub/slider";
import popup from './components/popup';
import customJquery from './components/custom-jquery';

import sliderSlick from './components/slider-slick';
import notifications from './components/notifications';

import FloatLabels from 'float-labels.js';
import subscription from './components/subscription-popup';
import navigationLanguage from './components/navigation-language';

lazySizes.init();

document.addEventListener('DOMContentLoaded', function() {
    new CookiePopup();
    new NCookiePopup();
    popup.init();
    navigationLanguage.init();

    sliderSlick.init();
    notifications.init();
    subscription.init();
	customJquery.init();

    if ($('.fl-form').length > 0) {
        new FloatLabels('form');
    }

    // When the user scrolls the page, execute myFunction
    var navbar = document.querySelector('.navbar-sticky');
    var sticky = 460;
    var lastScrollTop = 0;

    // carousels
    let carousels = document.querySelectorAll('.magazine__carousel');

    for (let i = 0; i < carousels.length; ++i) {
        let carousel = carousels[i];
        let carouselItems = carousel.querySelectorAll('.carousel-item');

        let carouselPages = carousel.querySelector('.magazine__carousel__pages');

        // If there's a single picture do not show pagination
        if (carouselPages) {
            carouselPages.textContent = "1/" + carouselItems.length;
        }

        $(carousel).on('slide.bs.carousel', (event) => {
            let slideTo = $(event.relatedTarget).index() + 1;
            carousel.querySelector('.magazine__carousel__pages').textContent = slideTo + "/" + carouselItems.length;
        })
    }

    // Sticky navbar Post
    if (document.querySelector('.navbar-sticky--full')) {
        document.addEventListener('scroll', (evt) => {
            var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

            if (window.pageYOffset >= sticky) {
                if (st > lastScrollTop){
                    // downscroll code
                    navbar.classList.add('active-down')
                    navbar.classList.remove('active-up');
                } else {
                    // upscroll code
                    navbar.classList.add('active-up')
                }
            } else {
                navbar.classList.remove('active-down');
                navbar.classList.remove('active-up');
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

        }, {
            capture: true,
            passive: true
        })
    }

    // Sticky navbar Post half
    if (document.querySelector('.navbar-sticky--half')) {
        document.addEventListener('scroll', (evt) => {
            var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

            if (window.pageYOffset >= sticky) {
                if (st > lastScrollTop) {
                    // downscroll code
                    navbar.classList.remove('active-up');
                } else {
                    // upscroll code
                    navbar.classList.add('active-up')
                }
            } else {
                navbar.classList.remove('active-down');
                navbar.classList.remove('active-up');
            }
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

        }, {
            capture: true,
            passive: true
        })
    }

    // Progress bar
    if (document.querySelector('#_progress')) {
        document.addEventListener(
            "scroll",
            function() {
              var scrollTop = document.documentElement["scrollTop"] || document.body["scrollTop"];
              var scrollBottom =
                (document.documentElement["scrollHeight"] ||
                  document.body["scrollHeight"]) - document.documentElement.clientHeight;
              var scrollPercent = scrollTop / scrollBottom * 100 + "%";
              document
                .getElementById("_progress")
                .style.setProperty("--scroll", scrollPercent);
            },
            { passive: true }
        );
    }

    // Aggregator tabs
    const aggregatorNavs = document.querySelectorAll('.aggregator-nav');
    const scrollOffset = 15;

    function arrows_toggle(el, prev, next) {
        prev.style.opacity = (el.scrollLeft > scrollOffset) ? 1 : 0;
        next.style.opacity = ((el.scrollWidth - scrollOffset) <= (el.scrollLeft + el.clientWidth)) ? 0 : 1;
    }

    if (aggregatorNavs.length) {

        for (let i = 0; i < aggregatorNavs.length; i++) {
            const aggregatorNav = aggregatorNavs[i];
            const _prev = aggregatorNav.querySelector('.aggregator-nav__prev');
            const _next = aggregatorNav.querySelector('.aggregator-nav__next');

            let ticking = false;

            // show hide right arrow on load
            if ((aggregatorNav.scrollWidth - scrollOffset) <= (aggregatorNav.scrollLeft + aggregatorNav.clientWidth)) {
                _next.style.opacity = 0;
            } else {
                _next.style.opacity = 1;
            }

            aggregatorNav.addEventListener('scroll', function (e) {
                if (!ticking) {
                    requestAnimationFrame(function () {
                        arrows_toggle(aggregatorNav, _prev, _next);
                        ticking = false;
                    });

                    ticking = true;
                }
            });

        }
    }

    // X-sliders with wrappers (pagination)
    let xSliders = document.querySelectorAll('.x-slider__wrapper');
    let sliders = []

    for (let i = 0; i < xSliders.length; ++i) {
        sliders.push(new Slider(xSliders[i]));
    }

    // On tab switch reinitialize all visible sliders
    $('a[data-toggle="tab"]').on('shown.bs.tab', () => {
        for (let i = 0; i < sliders.length; ++i) {
            sliders[i].setup();
        }
    })

    let secondaryMenu = document.querySelector('.secondary-menu');

    if (secondaryMenu) {

    let secondaryList = secondaryMenu.querySelector('ul');
    let secondaryMenuPrev = secondaryMenu.querySelector('.secondary-menu__prev');
    let secondaryMenuNext = secondaryMenu.querySelector('.secondary-menu__next');

    let scrollOffset = 15;
    let ticking = false;

    if (secondaryMenu.clientWidth !== secondaryMenu.scrollWidth) {
        secondaryList.style.justifyContent = 'flex-start';
    }

    // show hide right arrow on load
    if ((secondaryMenu.scrollWidth - scrollOffset) <= (secondaryMenu.scrollLeft + secondaryMenu.clientWidth)) {
        secondaryMenuNext.style.opacity = 0;
    } else {
        secondaryMenuNext.style.opacity = 1;
    }

    function arrows_toggle() {
        if (secondaryMenu.scrollLeft > scrollOffset) {
            secondaryMenuPrev.style.opacity = 1;
        } else {
            secondaryMenuPrev.style.opacity = 0;
        }

        if ((secondaryMenu.scrollWidth - scrollOffset) <= (secondaryMenu.scrollLeft + secondaryMenu.clientWidth)) {
            secondaryMenuNext.style.opacity = 0;
        } else {
            secondaryMenuNext.style.opacity = 1;
        }
    }

    secondaryMenu.addEventListener('scroll', function (e) {
        if (!ticking) {
            requestAnimationFrame(function () {
                arrows_toggle();
                ticking = false;
            });

            ticking = true;
        }
    });
    }

    let scrolling = false,
        previousTop = 0,
        scrollDelta = 0;

    // Show/hide secondary on mobile
    $(window).on('scroll', function () {
        if (!scrolling) {
            scrolling = true;
            (!window.requestAnimationFrame) ?
            setTimeout(autoHideHeader, 100): requestAnimationFrame(autoHideHeader);
        }
    });

    function autoHideHeader() {
        let currentTop = $(window).scrollTop();

        if ($('#mobile').is(':visible') || $('#tablet').is(':visible')) {
            checkStickyNavigation(currentTop);
        }

        previousTop = currentTop;
        scrolling = false;
    }

    function checkStickyNavigation(currentTop) {
        if (previousTop >= currentTop) {
            // if scrolling up or on top
            if ((previousTop - currentTop > scrollDelta) || (currentTop < 128)) {
                // secondary nav is fixed
                secondaryMenu.classList.remove('is-hidden');
            }

        } else {
            // if scrolling down, hide when below 128px
            if (currentTop > 128) {
                secondaryMenu.classList.add('is-hidden');
            }
        }
    }

});